import * as R from "ramda";
import i18n from "../i18n";
import { getPhotoForUserId } from "../../utils/utils";
import moment from "moment";
import { idx_data_axistilt } from "../db/datafixtures/datafixtures";
import { specsheetParser } from "../specsheet/specsheetParser";

const getTiltDegree = (tilt) => {
  const tiltObj = R.find(R.propEq("tilt_measure", tilt), idx_data_axistilt);

  return tiltObj ? tiltObj.tilt_deg : "";
};

const getThumbCuts = (currentThumbCuts) =>
  currentThumbCuts
    .map(
      (thumbCut) => `<tr class="row">
  <td class="col-xs-6 tech-info-title">${thumbCut.label.split(" ")[0]} ${
        thumbCut.label.split(" ")[1]
          ? thumbCut.label.split(" ")[1].slice(0, 1)
          : ""
      }</td>
  <td class="col-xs-6 tech-info-title">V:</td>
  <td class="col-xs-6 tech-info-value"><span style="margin-left: 1em;">${
    thumbCut.v && thumbCut.v != "undefined"
      ? (thumbCut.v * 1).toFixed(3)
      : "0.00"
  }</td>
  <td class="col-xs-6 tech-info-title" style="padding-left:1em">H:</td>
  <td class="col-xs-6 tech-info-value"><span style="margin-left: 1em;">${
    thumbCut.h && thumbCut.h != "undefined"
      ? (thumbCut.h * 1).toFixed(3)
      : "0.00"
  }</td>
</tr>`
    )
    .join("");

const getArsenalPhoto = (arsenalPhoto, userId) =>
  arsenalPhoto && arsenalPhoto != "null"
    ? `<img style="width: 100px; height: 125px" src="${getPhotoForUserId(
        userId
      )(arsenalPhoto)}">`
    : `<img style="width: 100px; height: 125px">`;

const getArsenalBalls = (arsenalDS, userId) =>
  R.slice(0, 4, arsenalDS).map(
    (arsenalBall) => `<td style="text-align: center;">
             <table style="font-size: 8px;">
                 <tr>
                     <td class='arsenalPhoto' align="center">
                        ${getArsenalPhoto(arsenalBall.photo, userId)}
                     </td>
                 </tr>
                 <tr class="row ball-info">
                     <td align="center">
                         <table style="font-size: 8px;">
                             <tr>
                                 <td class="arsenalBallName">${
                                   arsenalBall.ball_name
                                 }</td>
                                 <td class="arsenalManufacturer">${
                                   arsenalBall.manufacturer
                                 }</td>
                             </tr>
                             <tr>
                                 <td colspan="2" class="arsenalDateDrilled">${
                                   arsenalBall.date_drilled
                                     ? moment(arsenalBall.date_drilled).format(
                                         "YYYY-MM-DD"
                                       )
                                     : ""
                                 }</td>
                             </tr>
                         </table>
                     </td>
                 </tr>
                 <tr class="row ball-data-info">
                     <td style="text-align: center;">
                         <table style="font-size: 8px;">
                             <tr class="row">
                                 <td class="col-xs-6 tech-info-title">Surface: <span style="margin-left: 0.5em;">${
                                   arsenalBall.surface_preparation &&
                                   arsenalBall.surface_preparation !=
                                     "undefined"
                                     ? arsenalBall.surface_preparation
                                     : ""
                                 }</span></td>
                             </tr>
                             <tr class="row">
                                 <td class="col-xs-6 tech-info-title">Weight (Lbs): <span style="margin-left: 0.5em;">${
                                   arsenalBall.weight &&
                                   arsenalBall.weight != "undefined"
                                     ? arsenalBall.weight
                                     : ""
                                 }</span></td>
                             </tr>
                             <tr class="row">
                                 <td class="col-xs-6 tech-info-title">Layout: <span style="margin-left: 0.5em;">${
                                   arsenalBall.layout &&
                                   arsenalBall.layout != "undefined"
                                     ? arsenalBall.layout
                                     : ""
                                 }</span></td>
                             </tr>
                             <!--<tr class="row">-->
                                 <!--<td class="col-xs-6 tech-info-title">Weight Hole Size:</td>-->
                                 <!--<td class="col-xs-6 tech-info-value"><span style="margin-left: 1em;">${
                                   arsenalBall.weight_hole_size &&
                                   arsenalBall.weight_hole_size != "undefined"
                                     ? arsenalBall.weight_hole_size
                                     : ""
                                 }</span></td>-->
                             <!--</tr>-->
                             <!--<tr class="row">-->
                                 <!--<td class="col-xs-6 tech-info-title">Weight Hole Depth:</td>-->
                                 <!--<td class="col-xs-6 tech-info-value"><span style="margin-left: 1em;">${
                                   arsenalBall.weight_hole_depth &&
                                   arsenalBall.weight_hole_depth != "undefined"
                                     ? arsenalBall.weight_hole_depth
                                     : ""
                                 }</span></td>-->
                             <!--</tr>-->
                         </table>
                     </td>
                 </tr>
             </table>
         </td>`
  );

const isOvalThumb = (specSheet) => specSheet.thm_type === "Oval";
const isF1OdVisible = (specSheet) =>
  specSheet.f1_grip_type && specSheet.f1_grip_type !== "";
const isF2OdVisible = (specSheet) =>
  specSheet.f2_grip_type && specSheet.f2_grip_type !== "";

const getF1Info = (specSheet) =>
  `<div class="specsheet-result" bind-field-name="f1_span_full">${
    specSheet.f1_span_full && specSheet.f1_span_full != "undefined"
      ? specSheet.f1_span_full
      : ""
  }</div>
    <div class="specsheet-result" bind-field-name="f1_span_cut">${
      specSheet.f1_span_cut && specSheet.f1_span_cut != "undefined"
        ? specSheet.f1_span_cut
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_span_outer2_cut">${
      specSheet.f1_span_outer2_cut &&
      specSheet.f1_span_outer2_cut != "undefined"
        ? specSheet.f1_span_outer2_cut
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_lat">${
      specSheet.f1_lat && specSheet.f1_lat != "undefined"
        ? specSheet.f1_lat
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_for">${
      specSheet.f1_for && specSheet.f1_for != "undefined"
        ? specSheet.f1_for
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_rev">${
      specSheet.f1_rev && specSheet.f1_rev != "undefined"
        ? specSheet.f1_rev
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_grip_type">${
      specSheet.f1_grip_type && specSheet.f1_grip_type != "undefined"
        ? specSheet.f1_grip_type
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_size">${
      specSheet.f1_size && specSheet.f1_size != "undefined"
        ? specSheet.f1_size
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_od">${
      isF1OdVisible(specSheet) &&
      specSheet.f1_od &&
      specSheet.f1_od != "undefined"
        ? specSheet.f1_od
        : ""
    }</div>
    <div class="specsheet-result" bind-field-name="f1_oval">${
      !isF1OdVisible(specSheet) &&
      specSheet.f1_od &&
      specSheet.f1_od != "undefined"
        ? specSheet.f1_od
        : ""
    }</div>`;

const getF2Info = (specSheet) =>
  `<div class="specsheet-result" bind-field-name="f2_span_full">${
    specSheet.f2_span_full && specSheet.f2_span_full != "undefined"
      ? specSheet.f2_span_full
      : ""
  }</div>
  <div class="specsheet-result" bind-field-name="f2_span_cut">${
    specSheet.f2_span_cut && specSheet.f2_span_cut != "undefined"
      ? specSheet.f2_span_cut
      : ""
  }</div>
  <div class="specsheet-result" bind-field-name="f2_span_outer2_cut">${
    specSheet.f2_span_outer2_cut && specSheet.f2_span_outer2_cut != "undefined"
      ? specSheet.f2_span_outer2_cut
      : ""
  }</div>
  <div class="specsheet-result" bind-field-name="f2_lat">${
    specSheet.f2_lat && specSheet.f2_lat != "undefined" ? specSheet.f2_lat : ""
  }</div>
      <div class="specsheet-result" bind-field-name="f2_for">${
        specSheet.f2_for && specSheet.f2_for != "undefined"
          ? specSheet.f2_for
          : ""
      }</div>
      <div class="specsheet-result" bind-field-name="f2_rev">${
        specSheet.f2_rev && specSheet.f2_rev != "undefined"
          ? specSheet.f2_rev
          : ""
      }</div>
      <div class="specsheet-result" bind-field-name="f2_grip_type">${
        specSheet.f2_grip_type && specSheet.f2_grip_type != "undefined"
          ? specSheet.f2_grip_type
          : ""
      }</div>
      <div class="specsheet-result" bind-field-name="f2_size">${
        specSheet.f2_size && specSheet.f2_size != "undefined"
          ? specSheet.f2_size
          : ""
      }</div>
      <div class="specsheet-result" bind-field-name="f2_od">${
        isF2OdVisible(specSheet) &&
        specSheet.f2_od &&
        specSheet.f2_od != "undefined"
          ? specSheet.f2_od
          : ""
      }</div>
      <div class="specsheet-result" bind-field-name="f2_oval">${
        !isF2OdVisible(specSheet) &&
        specSheet.f2_od &&
        specSheet.f2_od != "undefined"
          ? specSheet.f2_od
          : ""
      }</div>`;

const getDates = (specsheet) =>
  `CR: ${moment(specsheet.created_at).format("L")} UP: ${moment(
    specsheet.updated_at
  ).format("L")} @ ${moment(specsheet.updated_at).format("LT")}`;

const withHtml = (contentWithHtml) => (content) =>
  withHtml
    ? `<html>
<body style="width: 8.5in; height: 11in; position: relative;">${content}</body>
</html>`
    : content;

export const printTemplate = ({
  specsheetImg,
  currentCustomer,
  specSheet,
  currentThumbCuts,
  arsenalDS,
  userId,
  contentWithHtml,
}) =>
  withHtml(contentWithHtml)(`
        <script>
          function printPage() {
            print();
          }
        </script>
        <style>
            table {
                font-family: Arial;
                font-size: 12px;
                border-collapse: collapse;
            }

            .panel-specsheet .panel-specsheet-image {
                position: relative;
                width: 595px;
                height: 728px;
                background-size: 583.1875px 698px;
                background-repeat: no-repeat;
                background-position: -5px -50px;
                top: -34px;
                left: -50px;
            }

            .panel-specsheet .panel-specsheet-image img.specsheet {
                position: absolute;
                top: -50px;
                left: -5px;
                width: 583.1875px;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result {
              position: absolute;
              font-size: 0.8em;
              min-height: 2em;
              min-width: 4em;
              margin-top: -0.5em;
              margin-left: -1em;
              padding-top: 0.5em;
              /*padding-left: 1em;*/
              /*opacity: 0.5em;*/
              background-color: transparent;
              text-align: center;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-title {
                position: absolute;
                font-size: 0.8em;
                min-height: 2em;
                min-width: 4em;
                margin-top: -0.5em;
                margin-left: -1em;
                padding-top: 0.5em;
                /*padding-left: 1em;*/
                /*opacity: 0.5em;*/
                background-color: transparent;
                text-align: center;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="name"] {
                top: 0%;
                left: 45%;
                min-width: 8em;
                font-size: 1.5em;
                text-align: left;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="hand"] {
                top: 6.3%;
                left: 17%;
                min-width: 8em;
                font-size: 1.5em;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="ball_grip"] {
                top: 6.3%;
                left: 37%;
                min-width: 11.5em;
                font-size: 1.5em;
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_span_full"] {
                top: 41%;
                left: 33%;
                font-size: 2.5em;
                /*display: none;*/
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_span_full"] {
                top: 41%;
                left: 57.5%;
                font-size: 2.5em;
                /*display: none;*/
            }

            /*.panel-specsheet .panel-specsheet-image.full-span .specsheet-result[bind-field-name="f1_span_full"] {*/
                /*display: block;*/
            /*}*/

            /*.panel-specsheet .panel-specsheet-image.full-span .specsheet-result[bind-field-name="f2_span_full"] {*/
                /*display: block;*/
            /*}*/

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_span_cut"] {
                top: 47.5%;
                left: 33%;
                font-size: 2.5em;
                /*display: none;*/
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_span_cut"] {
                top: 47.5%;
                left: 57.5%;
                font-size: 2.5em;
                /*display: none;*/
            }

            /*.panel-specsheet .panel-specsheet-image.cut-span .specsheet-result[bind-field-name="f1_span_cut"] {*/
                /*display: block;*/
            /*}*/

            /*.panel-specsheet .panel-specsheet-image.cut-span .specsheet-result[bind-field-name="f2_span_cut"] {*/
                /*display: block;*/
            /*}*/

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_span_outer2_cut"] {
                top: 53.5%;
                left: 33%;
                font-size: 2.5em;
                /*display: none;*/
            }

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_span_outer2_cut"] {
                top: 53.5%;
                left: 57.5%;
                font-size: 2.5em;
                /*display: none;*/
            }

            /*.panel-specsheet .panel-specsheet-image.outer2_cut-span .specsheet-result[bind-field-name="f1_span_outer2_cut"] {*/
                /*display: block;*/
            /*}*/

            /*.panel-specsheet .panel-specsheet-image.outer2_cut-span .specsheet-result[bind-field-name="f2_span_outer2_cut"] {*/
                /*display: block;*/
            /*}*/

            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_lat"] {
                top: 25%;
                left: 14%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_for"] {
                top: 33.5%;
                left: 14%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_rev"] {
                top: 16.5%;
                left: 14%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_grip_type"] {
                top: 14.5%;
                left: 27%;
                font-size: 0.8em;
                min-width: 11em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_size"] {
                top: 28%;
                left: 31%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_od"] {
                top: 22%;
                left: 31%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f1_oval"] {
                top: 22%;
                left: 31%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="bridge"] {
                top: 23%;
                left: 47%;
                font-size: 1.6em;
                min-height: 3.5em;
                padding-top: 1em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="clt"] {
                top: 13.7%;
                left: 47%;
                font-size: 1.6em;
                min-height: 3.5em;
                padding-top: 1em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_lat"] {
                top: 25%;
                right: 11.5%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_for"] {
                top: 33.5%;
                right: 11.5%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_rev"] {
                top: 16.5%;
                right: 11.5%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_grip_type"] {
                top: 14.5%;
                right: 25%;
                font-size: 0.8em;
                min-width: 11em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_size"] {
                top: 28%;
                right: 28%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_od"] {
                top: 22%;
                right: 28%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="f2_oval"] {
                top: 22%;
                right: 28%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_flex"] {
                top: 64%;
                left: 80%;
                min-width: 7.5em;
                font-size: 0.8em;
                font-weight: bold;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-title[bind-field-name="thm_offset"] {
              top: 69%;
              left: 80%;
              min-width: 7.5em;
              font-size: 0.8em;
              text-transform: uppercase;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_offset"] {
              top: 71.7%;
              left: 80%;
              min-width: 7.5em;
              font-size: 0.8em;
              font-weight: bold;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_lat_l"] {
                top: 75.5%;
                left: 30%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_for"] {
                top: 63.3%;
                left: 47.15%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_rev"] {
                top: 87.7%;
                left: 47.15%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_lat_r"] {
                top: 75.5%;
                right: 27.15%;
                font-size: 1.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_insert_type"] {
                top: 64%;
                left: 7.5%;
                font-size: 0.8em;
                font-weight: bold;
                min-width: 13.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_type"] {
                top: 2%;
                left: 10%;
                display: none;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_size"] {
                top: 78.8%;
                left: 46%;
                font-size: 1.5em;
                width:4.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_starting_bit_specsheet"] {
                top: 78.8%;
                left: 46%;
                font-size: 1.5em;
                width:4.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_round_od"] {
                top: 72.3%;
                left: 46%;
                font-size: 1.5em;
                width:4.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_od"] {
                top: 72.3%;
                left: 46%;
                font-size: 1.5em;
                width:4.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_round_taper"] {
                top: 63.9%;
                left: 100%;
                /* font-weight: bold; */
                min-width: 20em;
                font-size: 1.5em;
                text-align: left;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_starting_bit"] {
                top: 54.9%;
                left: 100%;
                font-size: 1.5em;
                /* width: 4.5em; */
                min-width: 20em;
                text-align: left;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_width"] {
                top: 57.9%;
                left: 100%;
                /* font-weight: bold; */
                min-width: 20em;
                font-size: 1.5em;
                text-align: left;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_degree"] {
                top: 60.9%;
                left: 100%;
                /* font-weight: bold; */
                min-width: 20em;
                font-size: 1.5em;
                text-align: left;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_od"] {
                top: 72.3%;
                left: 46%;
                font-size: 1.5em;
                width:4.5em;
            }
            .panel-specsheet .panel-specsheet-image .specsheet-result[bind-field-name="thm_oval_taper"] {
                top: 63.9%;
                left: 100%;
                /* font-weight: bold; */
                min-width: 20em;
                font-size: 1.5em;
                text-align: left;
            }

            .customer-info {
                line-height: 33px;
                font-size: 1.5em;
            }

            .tech-info {
                font-size: 1.2em;
            }

            .thumb-cut-info td {
                font-size: 1.5em;
                line-height: 1.5em;
            }

            .ball-info td, .ball-data-info td{
                font-size: 1.1em;
                line-height: 1.1em;
            }

        </style>
        <img style="width: 95%; position: absolute; z-index: 0" src="data:image/png;base64,${specsheetImg}">
        <div style="position: absolute; left: 40%">
            <table>
                <tr>
                    <td class="customer-info customerName">${
                      currentCustomer.firstname
                    } ${currentCustomer.lastname}</td>
                </tr>
                <tr>
                    <td class="customer-info customerDates">${getDates(
                      specSheet
                    )}&nbsp;</td>
                </tr>
                <tr>
                    <td class="customer-info customerEmail">${
                      currentCustomer.email
                    }&nbsp;</td>
                </tr>
                <tr>
                    <td class="customer-info customerPhone">${
                      currentCustomer.telephone
                    }&nbsp;</td>
                </tr>
                <tr>
            </tr>
            </table>
        </div>
        <div style="position: absolute; left: 65.91%; top: 35.5%;">
            <table class="row tech-info">
                <tr class="row">
                    <td class="col-xs-6 tech-info-title">PAP:</td>
                    <td class="col-xs-6 tech-info-value"><span style="margin-left: 0em;">${
                      currentCustomer.pap_h || ""
                    }</span> x <span>${
    currentCustomer.pap_v || ""
  }</span> x <span>${
    currentCustomer.pap_u_d || currentCustomer.pap_ud || ""
  }</span> </td>
                </tr>
                <tr class="row">
                    <td class="col-xs-6 tech-info-title">Axis Rot:</td>
                    <td class="col-xs-6 tech-info-value"><span style="margin-left: 0em;">${
                      currentCustomer.axis_rot || ""
                    }</span></td>
                </tr>
                <tr class="row">
                    <td class="col-xs-6 tech-info-title">Axis Tilt:</td>
                    <td class="col-xs-6 tech-info-value"><span style="margin-left: 0em;">${
                      currentCustomer.axis_tilt
                        ? currentCustomer.axis_tilt + '"'
                        : ""
                    } - ${
    currentCustomer.axis_tilt
      ? getTiltDegree(currentCustomer.axis_tilt) + "°"
      : ""
  }</span></td>
                </tr>
                <tr class="row">
                    <td class="col-xs-6 tech-info-title">Speed:</td>
                    <td class="col-xs-6 tech-info-value"><span style="margin-left: 0em;">${
                      currentCustomer.ball_speed || ""
                    }</span></td>
                </tr>
                <tr class="row">
                    <td class="col-xs-6 tech-info-title">Rev Rate:</td>
                    <td class="col-xs-6 tech-info-value"><span style="margin-left: 0em;">${
                      currentCustomer.rev_rate || ""
                    }</span></td>
                </tr>
            </table>
        </div>
        <div style="position: absolute; top: 18.5%; left: 1.5%;">
            <table>
                <tr class="row">
                    <td class="col-sm-12 print-specsheet-info">
                        <div class="panel-specsheet">
                            <div class="panel-specsheet-image full-span">
                                <div class="specsheet-result" bind-field-name="name">${
                                  specSheet.name &&
                                  specSheet.name != "undefined"
                                    ? specSheet.name
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="hand">${
                                  specSheet["hand"] &&
                                  specSheet["hand"] != "undefined"
                                    ? i18n.t(specSheet["hand"])
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="ball_grip">${
                                  specSheet.ball_grip &&
                                  specSheet.ball_grip != "undefined"
                                    ? i18n.t(specSheet.ball_grip)
                                    : ""
                                }</div>
                               ${getF1Info(specSheet)}
                                <div class="specsheet-result" bind-field-name="bridge">${
                                  specSheet.bridge &&
                                  specSheet.bridge != "undefined"
                                    ? specSheet.bridge
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="clt">${
                                  specSheet.clt && specSheet.clt != "undefined"
                                    ? specSheet.clt
                                    : ""
                                }</div>
                               ${getF2Info(specSheet)}
                                <div class="specsheet-result" bind-field-name="thm_flex">${
                                  specSheet.thm_flex &&
                                  specSheet.thm_flex != "undefined"
                                    ? specSheet.thm_flex
                                    : ""
                                }</div>
                                <div class="specsheet-title" bind-field-name="thm_offset">${i18n.t(
                                  "Offset"
                                )}</div>
                                <div class="specsheet-result" bind-field-name="thm_offset">${
                                  specSheet.thm_offset &&
                                  specSheet.thm_offset != "undefined"
                                    ? specSheet.thm_offset
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_lat_l">${
                                  specSheet.thm_lat_l &&
                                  specSheet.thm_lat_l != "undefined"
                                    ? specSheet.thm_lat_l
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_for">${
                                  specSheet.thm_for &&
                                  specSheet.thm_for != "undefined"
                                    ? specSheet.thm_for
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_rev">${
                                  specSheet.thm_rev &&
                                  specSheet.thm_rev != "undefined"
                                    ? specSheet.thm_rev
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_lat_r">${
                                  specSheet.thm_lat_r &&
                                  specSheet.thm_lat_r != "undefined"
                                    ? specSheet.thm_lat_r
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_insert_type">${
                                  specSheet.thm_insert_type &&
                                  specSheet.thm_insert_type != "undefined"
                                    ? specSheet.thm_insert_type
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_type">${
                                  specSheet.thm_type &&
                                  specSheet.thm_type != "undefined"
                                    ? specSheet.thm_type
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_size">${
                                  specSheet.thm_size &&
                                  specSheet.thm_size != "undefined"
                                    ? specSheet.thm_size
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_round_od">${
                                  !isOvalThumb(specSheet) &&
                                  specSheet.thm_round_od &&
                                  specSheet.thm_round_od != "undefined"
                                    ? specSheet.thm_round_od
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_od">${
                                  isOvalThumb(specSheet) &&
                                  specSheet.thm_od &&
                                  specSheet.thm_od != "undefined"
                                    ? specSheet.thm_od
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_round_taper">${i18n.t(
                                  "Taper Size"
                                )}: ${
    !isOvalThumb(specSheet) &&
    specSheet.thm_round_taper &&
    specSheet.thm_round_taper != "undefined"
      ? specSheet.thm_round_taper
      : ""
  }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_starting_bit">${i18n.t(
                                  "Starting bit"
                                )}: ${
    isOvalThumb(specSheet) &&
    specSheet.thm_oval_starting_bit &&
    specSheet.thm_oval_starting_bit != "undefined"
      ? specSheet.thm_oval_starting_bit
      : ""
  }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_starting_bit_specsheet">${
                                  isOvalThumb(specSheet) &&
                                  specSheet.thm_oval_starting_bit &&
                                  specSheet.thm_oval_starting_bit != "undefined"
                                    ? specSheet.thm_oval_starting_bit
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_width">${i18n.t(
                                  "Oval width"
                                )}: ${
    isOvalThumb(specSheet) &&
    specSheet.thm_oval_width &&
    specSheet.thm_oval_width != "undefined"
      ? specSheet.thm_oval_width
      : ""
  }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_degree">${i18n.t(
                                  "Oval degree"
                                )}: ${
    isOvalThumb(specSheet) &&
    specSheet.thm_oval_degree &&
    specSheet.thm_oval_degree != "undefined"
      ? specSheet.thm_oval_degree
      : ""
  }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_od">${
                                  isOvalThumb(specSheet) &&
                                  specSheet.thm_oval_od &&
                                  specSheet.thm_oval_od != "undefined"
                                    ? specSheet.thm_oval_od
                                    : ""
                                }</div>
                                <div class="specsheet-result" bind-field-name="thm_oval_taper">${i18n.t(
                                  "Taper Size"
                                )}: ${
    isOvalThumb(specSheet) &&
    specSheet.thm_oval_taper &&
    specSheet.thm_oval_taper != "undefined"
      ? specSheet.thm_oval_taper
      : ""
  }</div>
                                <div class="hide-oval-info"></div>
                            </div>
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div style="position: absolute; top: 83%; left: 2.82%;">
            <table style="font-size: 10px;">
                <tr class="row">
                   ${getArsenalBalls(arsenalDS, userId)} 
                </tr>
            </table>
        </div>
        <div style="position: absolute; top: 17.9%; left: 65.91%;">
            <table>
                <tr class="row">
                    <td>
                        <div>
                            ${specSheet.note || ""}
                        </div>
                    </td>
                </tr>
            </table>
        </div>
        <div style="position: absolute; top: 69%; left: 65.91%;">
            <table>
                <tr class="row thumb-cut-info">
                    <td>
                        <table>
                           ${getThumbCuts(currentThumbCuts)}
                        </table>
                    </td>
                </tr>
            </table>
        </div>
    `);
